import { render } from "./EventViewSurveySettings.vue?vue&type=template&id=61787916&lang=pug"
import script from "./EventViewSurveySettings.vue?vue&type=script&lang=js"
export * from "./EventViewSurveySettings.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__